






import {Vue, Component, Prop, Watch, Emit} from 'vue-property-decorator';

@Component({})
export default class ToolbarButton extends Vue {
    @Prop() icon: string;
    @Prop() text: string;

    @Emit() click() {}
}
